import { NextRequest } from "next/server";

export function isNumeric(value: string) {
  return /^-?\d+$/.test(value);
}

export const getPaginationItems = (page: number, total: number) => {
  let values: number[] = [];
  if (page < 2) {
    values = [0, 1, 2, 3, 4];
  } else if (page > total - 2) {
    values = [total - 4, total - 3, total - 2, total - 1, total];
  } else {
    values = [page - 2, page - 1, page, page + 1, page + 2];
  }
  return values.filter((v) => v <= total);
};

export const getIdByRequest = (request: NextRequest) => {
  return request.nextUrl.pathname.split("/").filter(Boolean).pop();
};
